import { ApolloLink, Observable } from 'apollo-link'
import store from '../../stores/reduxStore'
import {logout} from '../../actions/user'
import {getAccessToken, refreshTokenMutation} from './jwt'

export class AuthLink extends ApolloLink {
  tokenRefreshingPromise = null

  injectClient = (client) => {
    this.client = client
  }

  refreshToken = () => {
    if (!this.tokenRefreshingPromise) this.tokenRefreshingPromise = refreshTokenMutation(this.client)
    return this.tokenRefreshingPromise
  }

  setTokenHeader = (operation) => {
    const token = getAccessToken()
    if (token && operation.operationName !== 'refreshUserToken') {
      const oldHeaders = operation.getContext().headers
      operation.setContext({ headers: { ...oldHeaders, authorization: `Bearer ${token}` } })
    }
  }

  request(operation, forward) {
    // set token in header
    this.setTokenHeader(operation)
    // try refreshing token once if it has expired
    return new Observable(observer => {
      let subscription, innerSubscription
      try {
        subscription = forward(operation).subscribe({
          next: observer.next.bind(observer),
          complete: observer.complete.bind(observer),
          error: netowrkError => {
            if (operation.operationName === 'refreshUserToken') return store.dispatch(logout())

            if (netowrkError.statusCode === 401) {
              this.refreshToken().then(refreshTokenData => {
                if (refreshTokenData) {
                  // set new token and retry operation
                  this.setTokenHeader(operation)
                  innerSubscription = forward(operation).subscribe(observer)
                }
              }).catch(() => {
                store.dispatch(logout())
              })
            } else {
              observer.error(netowrkError)
            }
          },
        })
      } catch (e) {
        observer.error(e)
      }
      return () => {
        if (this.tokenRefreshingPromise) this.tokenRefreshingPromise = null
        if (subscription) subscription.unsubscribe()
        if (innerSubscription) innerSubscription.unsubscribe()
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/api/AuthLink.js